import { placeholderImage } from './placeholder-image.js';
import { isPresent } from './type-guards.js';

// Packshot image type
const FRONT_IMAGE = 'Front';
/**
 * Returns Front image if it's set, otherwise placeholder image
 */ function getFrontImage(images) {
    if (!isPresent(images)) {
        return placeholderImage;
    }
    var ref;
    const image1 = (ref = images.find((image)=>image.label === FRONT_IMAGE
    )) !== null && ref !== void 0 ? ref : images[0];
    return image1 ? image1 : placeholderImage;
}

export { getFrontImage as default };
//# sourceMappingURL=get-front-image.js.map
